module.exports = __webpack_public_path__ + "static/media/arrowin.93321133.svg";